module.exports = __webpack_public_path__ + "img/addcon.70d24d2d.png";